import { graphql, useStaticQuery } from 'gatsby';

export default function AiMenuLinks() {
  const AiMenu = useStaticQuery(graphql`
    query MyAiQuery {
      allMenuLinkContentAi {
        nodes {
          id: drupal_id
          langcode
          parent: drupal_parent_menu_item
          link {
            uri
          }
          title
          weight
        }
      }
      allPathAliasPathAlias {
        nodes {
          alias
          langcode
          path
        }
      }
    }
  `);

  return AiMenu;
}
